const workWeekSchedules = [
  {
    name: "Five-day",
    value: "FIVE_DAY",
  },
  {
    name: "Six-day",
    value: "SIX_DAY",
  },
  {
    name: "Daily-based",
    value: "DAILY_BASED",
  },
];

export default workWeekSchedules;
